import Vue from 'vue';
import App from './App.vue';
import router from './router';

import { BootstrapVue } from 'bootstrap-vue';
Vue.use(BootstrapVue);

import { VueMaskDirective } from 'v-mask'
Vue.directive('mask', VueMaskDirective);

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
